export const tabularNums = { fontFeatureSettings: '"tnum" on, "lnum" on' };
